import { request } from '@aqx-core/common/request';

import {
  IDealHistory,
  IGetDealHistoryParams,
  IGetOrderByIdParams,
  IGetOrderByIdV2Params,
  IGetOrderBySymbolParams,
  IGetOrderCountsResponse,
  IGetOrderExportDealHistoriesParams,
  IGetOrderExportHistoriesParams,
  IGetOrderExportParams,
  IGetOrderExportPendingParams,
  IGetOrderHistoryParams,
  IOrder,
  IOrderHistory,
  IPendingOrder
} from '../model/types';

export default {
  getAllOpenPositions: (params: IGetOrderBySymbolParams, signal?: AbortSignal) =>
    request.get<IOrder[]>('/api/trade/order/v1', { params, signal }),
  getOpenAndPendingOrderCounts: (params: IGetOrderBySymbolParams, signal?: AbortSignal) =>
    request.get<IGetOrderCountsResponse>('/api/trade/order/v1/counts', { params, signal }),
  getDealHistories: (params: IGetDealHistoryParams, signal?: AbortSignal) =>
    request.get<IDealHistory[]>('/api/trade/order/v1/deal/histories', { params, signal }),
  getOrderDetail: (params: IGetOrderByIdParams) => request.get<IOrder>('/api/trade/order/v1/details', { params }),
  getOrderDetailV2: (params: IGetOrderByIdV2Params) => request.get<IOrder>('/api/order/v2/details', { params }),
  getOrderHistories: (params: IGetOrderHistoryParams, signal?: AbortSignal) =>
    request.get<IOrderHistory[]>('/api/trade/order/v1/histories', { params, signal }),
  getOrderHistoriesV3: (params: IGetOrderHistoryParams, signal?: AbortSignal) =>
    request.get<IOrderHistory[]>('/api/order/v3/histories', { params, signal }),
  getAllPendingOrders: (params: IGetOrderBySymbolParams, signal?: AbortSignal) =>
    request.get<IPendingOrder[]>('/api/trade/order/v1/pending', { params, signal }),
  getPendingOrderDetail: (params: IGetOrderByIdParams, signal?: AbortSignal) =>
    request.get<IPendingOrder>('/api/trade/order/v1/pending/details', { params, signal }),
  // Export APIs
  export: (params?: IGetOrderExportParams) =>
    request.get('/api/trade/order/export/v1', { params, responseType: 'blob' }),
  exportDealHistories: (params: IGetOrderExportDealHistoriesParams) =>
    request.get('/api/trade/order/export/v1/deal/histories', { params, responseType: 'blob' }),
  exportHistories: (params?: IGetOrderExportHistoriesParams) =>
    request.get('/api/trade/order/export/v1/histories', { params, responseType: 'blob' }),
  exportPending: (params?: IGetOrderExportPendingParams) =>
    request.get('/api/trade/order/export/v1/pending', { params, responseType: 'blob' }),
  exportTransactionHistories: (params?: IGetOrderExportParams) =>
    request.get('/api/trade/order/export/v1/transaction/histories', { params, responseType: 'blob' })
};
